import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-status-screen-component',
  imports: [CommonModule],
  templateUrl: './status-screen-component.html',
  styleUrl: './status-screen-component.css'
})
export class StatusScreenComponent {
  @Input() bgImage: string | null = '/assets/images/status-screen-bg.png';

}
